import { Container, Divider } from "@material-ui/core";
import { Box, Grid, Typography } from "@mui/material";
import axios from "axios";
import {
  CurrencyDisplay,
  CustomTable,
  ModalError,
  Page,
  PrimaryButton,
  SkeletonComponent,
  SongUsageTrendChart,
  SongUsageTrendSummarytCard,
} from "components";
import { HeaderTitle } from "layouts";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import {
  arrayToCommaSeparatedString,
  downloadFileFromRes,
  getErrors,
} from "utils";

const PenciptaDetailReviewLagu = () => {
  const classes = globalStyles();
  const history = useHistory();
  const { id } = useParams();
  const { state } = useLocation();
  const { song, queryParams } = state;
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [loadingPage, setLoadingPage] = useState(false);
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [dataTable, setDataTable] = useState([]);
  const [songDetail, setSongDetail] = useState({
    composers: [],
    iswc: "",
    publisherName: "",
  });
  const [chartReport, setChartReport] = useState({
    revenue: 0,
    traffic: 0,
    month: "",
    totalRevenue: 0,
    totalTraffic: 0,
  });
  const params = {
    year: queryParams?.year,
    dsp_ids: queryParams?.dsp_ids,
  };
  const handleChangeChartReport = (value, key) => {
    setChartReport(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  console.log({ songDetail });
  const onClickChartAxis = data => {
    if (chartData?.datasets.length > 0) {
      const { dataIndex, axisValue } = data;
      const monthName = moment(axisValue, "MMM YY").format("MMMM");
      const monthTotalTraffic = chartData?.datasets[0]?.listener?.[dataIndex];
      const monthTotalRevenue = chartData?.datasets[0]?.data?.[dataIndex];

      handleChangeChartReport(monthTotalTraffic, "traffic");
      handleChangeChartReport(monthTotalRevenue, "revenue");
      handleChangeChartReport(monthName, "month");
    }
  };

  const getResponse = async () => {
    try {
      const res = await axios.get(
        `${hardBaseUrl}/composer/song-usage/v2/detail-song/${id}`,
        {
          headers,
          params,
        }
      );
      const { data } = res?.data;
      const { song_usages } = data;
      setSongDetail({
        composers: arrayToCommaSeparatedString(data?.composer_names),
        iswc: data?.song?.iswc || "-",
        publisherName: data?.publisher_name || "-",
      });
      setChartReport(currentState => ({
        ...currentState,
        totalRevenue: data?.revenue,
        totalTraffic: data?.stream,
      }));
      setDataTable(song_usages);

      const labels = song_usages?.map(item =>
        moment(`${item.month} ${item.year}`).format("MMM YY")
      );
      const datasets = [
        {
          label: "",
          data: song_usages?.map(chartItem => chartItem?.revenue),
          listener: song_usages?.map(chartItem => chartItem?.stream),
          color: "#9545EB",
          showMark: false,
        },
      ];
      setChartData({
        labels,
        datasets,
      });
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  const handleDownloadXLSX = async () => {
    try {
      const res = await axios.get(
        `${hardBaseUrl}/composer/song-usage/v2/detail-song/export/${id}`,
        {
          headers,
          params,
          responseType: "blob",
        }
      );
      downloadFileFromRes(res);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  useEffect(() => {
    getResponse();
  }, []);

  return (
    <Page className={classes.root} title="Song Usage Detail">
      {loadingPage ? (
        <SkeletonComponent variant="wave" />
      ) : (
        <Container maxWidth={false}>
          <HeaderTitle
            title={
              <Box>
                <Typography fontSize="24px">
                  Song Title:{" "}
                  <Typography component="span" fontSize="24px" fontWeight={700}>
                    {song?.song_title}
                  </Typography>
                </Typography>
                <Typography fontWeight={400} fontSize="18px">
                  {`Year of Song Usage: ${queryParams?.year}`}
                </Typography>
              </Box>
            }
            breadcrumbData={breadcrumbData}
            backButton
          />
          <Divider className={classes.divider} />
          <Box border="1px solid #D1D5DC" borderRadius="6px" p="24px">
            {songDetailList(songDetail)?.map((item, index) => (
              <Grid container key={index}>
                <Grid item xs={2}>
                  <Typography>{item?.title}</Typography>
                </Grid>
                <Grid item xs={10}>
                  <Box display="flex">{item?.name || "-"}</Box>
                </Grid>
              </Grid>
            ))}
          </Box>
          <Typography fontSize="24px" fontWeight={500} my="24px">
            Trend of Song Usage
          </Typography>
          <Box py="20px" border="1px solid #D1D5DC" borderRadius="6px">
            <SongUsageTrendChart
              chartData={chartData}
              onAxisClick={(_, data) => onClickChartAxis(data)}
            />
          </Box>
          <SongUsageTrendSummarytCard chartReport={chartReport} />
          <Grid container columnSpacing={2} my={2} justifyContent="right">
            <Grid item>
              <PrimaryButton
                label="Download PDF"
                onClick={() =>
                  history.push({
                    pathname: "/admin/review-lagu/detail/print-report",
                    state: {
                      song,
                      queryParams,
                      songDetailList: songDetailList(songDetail),
                      chartData,
                      chartReport,
                      dataTable,
                    },
                  })
                }
              />
            </Grid>
            <Grid item>
              <PrimaryButton
                label="Download XLSX"
                onClick={handleDownloadXLSX}
              />
            </Grid>
          </Grid>
          <CustomTable columnTable={columnTable} data={dataTable} />
        </Container>
      )}
    </Page>
  );
};

const breadcrumbData = [
  {
    label: "Home",
    link: "/pencipta/dashboard-pencipta",
  },
  {
    label: "Song Usage",
    link: "/pencipta/review-lagu",
  },
  {
    label: "Song Detail",
    active: true,
  },
];
const songDetailList = songDetail => [
  {
    title: "ISWC Code",
    name: songDetail?.iswc,
  },
  {
    title: "Publisher",
    name: songDetail?.publisherName,
  },
  {
    title: "Composer",
    name: songDetail?.composers,
  },
];
const columnTable = [
  {
    name: "month",
    title: "Month",
  },
  {
    name: "year",
    title: "Year",
  },
  {
    name: "stream",
    title: "Traffic",
    headerAlign: "right",
    renderText: item => <CurrencyDisplay value={item} />,
  },
  {
    name: "revenue",
    title: "Revenue",
    headerAlign: "right",
    renderText: item => <CurrencyDisplay value={item} prefix="Rp" />,
  },
];
export default PenciptaDetailReviewLagu;
